import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives } from "vue";
import Editor from '@tinymce/tinymce-vue';
//引入tinymce开启本地模式
import 'tinymce/tinymce';
//引入图标和主题等
import 'tinymce/themes/silver/theme';
import 'tinymce/icons/default/icons';
import 'tinymce/models/dom';
//引入插件
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/advlist';
import 'tinymce/plugins/link';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/charmap';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/code';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/table';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/wordcount';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/image';

import { computed, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XTinyMce',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose,
      __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var value = computed({
      get: function get() {
        return props.modelValue || '';
      },
      set: function set(newValue) {
        emits('update:modelValue', newValue);
      }
    });
    var initStatus = ref(false);
    function init() {
      initStatus.value = true;
    }
    function getValue() {
      return value.value;
    }
    function clearValue() {
      value.value = '';
    }
    __expose({
      getValue: getValue,
      clearValue: clearValue
    });
    return function (_ctx, _cache) {
      var _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", {
        class: _normalizeClass({
          'loading': !_unref(initStatus)
        })
      }, [_createVNode(_unref(Editor), {
        onInit: _cache[0] || (_cache[0] = function ($event) {
          return init();
        }),
        init: {
          height: 500,
          language: 'zh_CN',
          plugins: ['advlist', 'autolink', 'lists', 'link', 'charmap', 'preview', 'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen', 'insertdatetime', 'table', 'code', 'help', 'wordcount'],
          toolbar1: 'undo redo | blocks | fontfamily fontsize | \
          strikethrough lineheight underline bold italic backcolor | \
          h1 h2 h3 h4 h5 h6 hr | \
          alignleft aligncenter alignright alignjustify | \
          bullist numlist outdent indent | removeformat'
        },
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
          return _isRef(value) ? value.value = $event : null;
        })
      }, null, 8, ["modelValue"])], 2)), [[_directive_loading, !_unref(initStatus)]]);
    };
  }
});